import React, { useState } from 'react';
import Panel from '../../../components/common/Panel/Panel';
import Select from '../../../components/common/Select';
import styles from './TeacherOverviewPage.module.css';
import { mockClasses, mockLessons, mockUsers } from './mockData';
import { useNavigate } from 'react-router-dom';
import { TabPanel } from '../../../components/common/TabPanel/TabPanel';
import { IconButton } from '../../../components/common/IconButton/IconButton';
import { DeleteIcon } from '../../../components/common/icons/deleteIcon';
import { ChangePasswordIcon } from '../../../components/common/icons/changePassword';
import ConfirmationModal from '../../../components/common/ConfirmationModal';

export const TeacherOverviewPage: React.FC = () => {
  const [selectedClass, setSelectedClass] = useState(mockClasses[0]);
  const navigate = useNavigate();

  const students = mockUsers.filter(user => user.role === 'student');
  const teachers = mockUsers.filter(user => user.role === 'teacher');

  const [action, setAction] = useState<'delete' | 'changePassword' | null>(null);

  const handleLessonClick = (lessonId: string) => {
    navigate(`/docent/lessen/${lessonId}`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.classSelect}>
        <div className={styles.header}>{/* <UserHeader username={user?.name || 'codey'} /> */}</div>
        <Select
          value={selectedClass.id}
          onChange={value => setSelectedClass(mockClasses.find(c => c.id === value) || mockClasses[0])}
          options={mockClasses.map(c => ({ value: c.id, label: c.name }))}
          label="Select Class"
        />
      </div>

      <div className={styles.panels}>
        <Panel className={styles.panel} title="Gebruikers">
          <TabPanel
            tabs={[
              {
                id: 'students',
                label: 'Studenten',
                content: (
                  <div className={styles.userList}>
                    {students.map(student => (
                      <div key={student.id} className={styles.userItem}>
                        <div className={styles.userInfo}>
                          <h3>{student.name}</h3>
                          <p>{student.email}</p>
                        </div>
                        <div className={styles.userActions}>
                          <IconButton icon={ChangePasswordIcon} onClick={() => setAction('changePassword')} />
                          <IconButton icon={DeleteIcon} onClick={() => setAction('delete')} />
                        </div>
                      </div>
                    ))}
                  </div>
                ),
              },
              {
                id: 'teachers',
                label: 'Docenten',
                content: (
                  <div className={styles.userList}>
                    {teachers.map(teacher => (
                      <div key={teacher.id} className={styles.userItem}>
                        <div className={styles.userInfo}>
                          <h3>{teacher.name}</h3>
                          <p>{teacher.email}</p>
                        </div>
                        <div className={styles.userActions}></div>
                      </div>
                    ))}
                  </div>
                ),
              },
            ]}
          />
        </Panel>
        <Panel className={styles.panel} title="Lessen">
          <div className={styles.lessonList}>
            {mockLessons.map(lesson => (
              <div key={lesson.id} className={styles.lessonItem} onClick={() => handleLessonClick(lesson.id)}>
                <div className={styles.lessonTitle}>
                  <h3>{lesson.title}</h3>
                  <span className={styles.lessonStatus}>{lesson.status}</span>
                </div>
                <p className={styles.lessonDescription}>{lesson.description}</p>
                <span className={styles.lessonDate}>{lesson.dateCreated}</span>
              </div>
            ))}
          </div>
        </Panel>
      </div>
      <ConfirmationModal
        isOpen={action === 'delete'}
        onClose={() => setAction(null)}
        onConfirm={() => {
          console.log('confirm');
          setAction(null);
        }}
        text={`Weet je zeker dat je deze actie wilt uitvoeren?`}
      />

      {/* <ChangePasswordModal
        isOpen={action === 'changePassword'}
        onClose={() => setAction(null)}
        onSubmit={async (currentPassword, newPassword) => {
          console.log('Change password:', currentPassword, newPassword);
        }}
        userId={user?.id || ''}
      /> */}
    </div>
  );
};
